import { RouteModel } from 'core/router/model';

export const TemplateNewRoute = new RouteModel<{ formUuid: string }>(
  'templates_template_add',
  'new'
);

export const TemplateRoute = new RouteModel<{ formUuid: string; view?: 'roles' }>(
  'templates_template_edit',
  ':formUuid/:view(roles)?',
  {}
);

export const TemplatesRootRoute = new RouteModel('templatesroot', '', {
  exact: true,
});

export const TemplatesRoute = new RouteModel('templates', 'templates', {
  title: 'Templates',
  children: [TemplatesRootRoute, TemplateNewRoute, TemplateRoute],
});

export const DistributeTemplateRoute = new RouteModel<{ hash: string }>(
  'distribute_templates',
  '/distribute/:hash'
);

export const DistributeTemplateWebRoute = new RouteModel<{ hash: string }>(
  'distribute_templates_web',
  '/web/distribute/:hash'
);
